import { createSlice } from "@reduxjs/toolkit";
import { fetchPublicTeacherProfile, fetchPublicTeachers } from "./operation.js";

const initialState = {
  teacher: null,
  rating: {
    average: null,
    count: 0,
  },
  score: null,
  slots: [],
  teachers: {
    teachers: [],
    total: 0,
    totalPages: 1,
    currentPage: 1,
  },
  loading: false,
  error: null,
};

const publicTeacherSlice = createSlice({
  name: "publicTeacher",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Загрузка профиля преподавателя
      .addCase(fetchPublicTeacherProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicTeacherProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.score = action.payload.score;
        state.teacher = action.payload.teacher;
        state.slots = action.payload.slots;
        state.rating = action.payload.rating || { average: null, count: 0 };
      })
      .addCase(fetchPublicTeacherProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Загрузка всех преподавателей
      .addCase(fetchPublicTeachers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload;
      })
      .addCase(fetchPublicTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default publicTeacherSlice.reducer;
